module.exports = __webpack_public_path__ + "img/parenting.21f9ce9.svg";